import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import RankingList from "../../components/RankingList/";
import GameApi from "./../../services/GameApi";

import Skeleton from "@mui/material/Skeleton";
import "./styles.scss";
import ApiCommonContent from "../../services/GenericContent";
import { CommonContent, ContentKey } from "../../types/Types";
import { Ranking } from "../../types/Game";

const RankingPage = () => {
  const [users, setUsers] = React.useState<Ranking[]>();
  const [commonContent, setCommonContent] = React.useState<
    CommonContent[] | undefined
  >(undefined);

  useEffect(() => {
    if (!users) {
      GameApi.getRankingUsers()
        .then(({ data }) => {
          const users: Ranking[] = [];
          data.map((user, index) => {
            users.push({
              position: index + 1,
              avatar: user.profileUrl,
              name: user.name,
              countryCode: user.countryCode,
              country: user.country,
              points: user.points,
            });
          });
          setUsers(users);
        })
        .catch((e) => console.error(e));
    }
  }, [users]);

  useEffect(() => {
    if (!commonContent) {
      ApiCommonContent.getContent().then((content) => {
        setCommonContent(content);
      });
    }
  });

  return (
    <React.Fragment>
      <CssBaseline />
      <Container className="containerWhite" maxWidth="md">
        <AppBar position="static">
          <Toolbar className="toolBarBlue">
            <IconButton
              onClick={() => {
                window.history.back();
              }}
              edge="start"
              color="inherit"
              aria-label="menu"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {ApiCommonContent.getKeyValue(
                commonContent || [],
                ContentKey.GLOBAL_RANKING
              )}
            </Typography>
          </Toolbar>
        </AppBar>
        {users && <RankingList data={users} />}
        {!users && (
          <div style={{ margin: 5, marginTop: 10 }}>
            <Skeleton
              style={{ marginTop: 5 }}
              variant="rectangular"
              width={"98%"}
              height={58}
            />
            <Skeleton
              style={{ marginTop: 5 }}
              variant="rectangular"
              width={"98%"}
              height={58}
            />
            <Skeleton
              style={{ marginTop: 5 }}
              variant="rectangular"
              width={"98%"}
              height={58}
            />
            <Skeleton
              style={{ marginTop: 5 }}
              variant="rectangular"
              width={"98%"}
              height={58}
            />
            <Skeleton
              style={{ marginTop: 5 }}
              variant="rectangular"
              width={"98%"}
              height={58}
            />
          </div>
        )}
      </Container>
    </React.Fragment>
  );
};

export default RankingPage;
